import { css } from '@emotion/core'

export const styles = {
  container: css`
    position: absolute;
    top: 120%;
    left: 50%;
    transform: translateX(-50%);

    background: white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05), 0 10px 7px rgba(0, 0, 0, 0.03);
    border-radius: 5px;

    display: flex;
    flex-direction: column;
    align-items: stretch;

    overflow: hidden;
  `,
}
